// color name sfrom www.color-name.com

const colors = {
    // generic color do not remove
    white: '#ffffff',
    black: '#000',
    antiFlashWhite: '#f3f3f3',
    seaGreen: '#2e844a',
    cadmiumRed: '#ea001e',

    // default colors
    blueJeans: '#56c4eb',
    spanishRed: '#e60023',
    darkSeaGreen: '#0bb723',
    onyx: '#393939',
    chineseSilver: '#cccccc',
    cinnabar: '#ef4323',
    lightGreen: '#CDEFC4',

    // crunchy colors
    tangelo: '#f47521',
    goldenYellow: '#fab818',
    royalOrange: '#ff944d',
    darkGunmetal: '#23252b',
    venetianRed: '#ef4323',
    White1: '#f8f8f8',
    orangeBase: '#ff640a',
    crayola: '#FF8036',
    tangerine: '#FF9C62',
    gray: '#f2f2f2',
    red: '#e9214d',
    blueLight: '#2f5161',
    grey25: '#A0A0A0',
    silver: '#dadada',
    woodsmoke: '#141519',
    grey28: '#4A4E58',
    lightBlue: '#548094',
    cultured: '#f8f6f3',
    pomegranateBase: '#C13937',
    darkGray: '#59595b',
    softSand: '#d4cbaf',
    floralWhite: '#FBF9F3',
    darkVanilla: '#D4CBAF',
    darkGreen: '#3A7846',
    ivory: '#FBF9F3',
    darkOrange: '#A43F06',
    mediumGray: '#707176',
    dutchWhite: '#ECE1C2',
    slateGray: '#59595B'
}

const defaultTheme = {
    // Update the values based on site requirement

    primaryColor: colors.tangelo,
    secondaryColor: colors.royalOrange,

    bodybgColor: colors.white,
    pageBgColor: colors.white,
    primaryBgColor: colors.floralWhite,
    secondaryPageBgColor: colors.cultured,

    bodybgColorInverted: colors.antiFlashWhite,
    textColorInverted: colors.black,
    lightBlue: colors.lightBlue,

    headerBgColor: colors.black,
    headerLogoBgColor: colors.white, // if require else make it transparent
    listMenuColor: colors.white,

    bgColor1: colors.skyBlue,
    bgColor2: colors.blueJeans,
    headerItemsBadgesBgColor: colors.red,

    textColor: colors.black,
    textColorInvert: colors.white,
    errorRed: colors.cadmiumRed,
    promoTextcolor: colors.seaGreen,
    toastBgColor: colors.lightGreen,

    linkColor: colors.tangelo,

    primaryButtonColor: colors.orangeBase,
    buttonHoverColor: colors.crayola,
    primaryButtonText: colors.black,
    primaryButtonDisabledText: colors.tangerine,
    buttonActiveOutlineColor: colors.goldenYellow,
    wishlistIconColor: colors.tangelo,
    wishlistBgColor: colors.gray,
    outlineButtonColor: colors.black,
    outlineButtonText: colors.black,

    buttonTextColor: colors.black,
    buttonTextColorInvert: colors.white,

    inputFocusBgColor: colors.white,
    borderColor1: colors.chineseSilver,
    borderColor2: colors.darkVanilla,

    modalPopupBgColor: colors.white,
    modalPopupColor: colors.black,

    successAlertPopColor: colors.seaGreen,
    errorAlertPopColor: colors.cadmiumRed,
    darkGunmetal: colors.darkGunmetal,
    mainMenuColor: colors.White1,
    orangeBaseColor: colors.orangeBase,
    blueLight: colors.blueLight,
    grey25: colors.grey25,
    silver: colors.silver,
    woodsmoke: colors.woodsmoke,
    pomegranateBase: colors.pomegranateBase,
    errorRed1: colors.venetianRed,
    charcoalBlue: colors.grey28,
    darkGray: colors.darkGray,
    softSand: colors.softSand,
    darkGreen: colors.darkGreen,
    ivory: colors.ivory,
    darkOrange: colors.darkOrange,
    mediumGray: colors.mediumGray,
    dutchWhite: colors.dutchWhite,
    slateGray: colors.slateGray
}

const getCustomColors = () => {
    return defaultTheme
}

const customColors = getCustomColors()

export default customColors
